module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_kagoshima-d03925ed5a011c62aaf9a6b335500f56.png";